import React, { Component } from "react";
import Modal from "react-modal";
import Constants from "../../Utils/Constants";
import Naira from "../../Utils/naira.jpg";
import { Document, Page, Text, View, StyleSheet, PDFViewer, Svg, Rect, Image, } from "@react-pdf/renderer";
// import Naira from 'react-naira' 

// Create styles
const borderColor = 'gray';
const tableBorderColor = 'black';
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  section: {
    margin: 10,
    padding: 0,
    color: "black",
  },
  centerImage: {
    alignItems: "center",
    flexGrow: 1,
  },
  viewer: {
    width: window.innerWidth / 2, //the pdf viewer will take up all of the width and height
    height: window.innerHeight / 1.5,
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Oswald'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Oswald'
  },
  text: {
    marginTop: 2,
    marginLeft: 18,
    width: 490,
    fontSize: 14,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
    border: 2,
    borderColor: borderColor,
    padding: 3,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: borderColor,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});

const styleHeader = StyleSheet.create({
  container: {
    flexDirection: 'row',
    bordertColor: tableBorderColor,
    border: 0,
    fontSize: 12,
    marginTop: 15,
    marginLeft: 18,
    //backgroundColor: '#bff0fd',
    alignItems: 'right',
    //height: 24,
    textAlign: 'right',
    fontStyle: 'bold',
    // flexGrow: 1,
  },
  sno: {
    width: '10%',
    bordertColor: tableBorderColor,
    border: 1,
    paddingRight: 8,
  },
  originNo: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
  },
  fileNumber: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
  },
  voucherNo: {
    width: '25%',
    bordertColor: tableBorderColor,
    border: 1,
    textAlign: 'left',
    paddingLeft: 8,
  },
  beneficiaries: {
    width: '25%',
    bordertColor: tableBorderColor,
    border: 1,
    textAlign: 'left',
    paddingLeft: 8,
  },
  amount: {
    width: '25%',
    bordertColor: tableBorderColor,
    border: 1,
    alignItems: 'right',
    paddingRight: 8,
  },
  date: {
    width: '25%',
    bordertColor: tableBorderColor,
    border: 1,
    textAlign: 'left',
    paddingLeft: 8,
  },
});

const styleRows = StyleSheet.create({
  row: {
    flexDirection: 'row',
    borderColor: tableBorderColor,
    border: 0,
    alignItems: 'right',
    fontSize: 12,
    marginLeft: 18,
    fontStyle: 'normal',
    //height: 24,
  },
  sno: {
    width: '10%',
    textAlign: 'right',
    bordertColor: tableBorderColor,
    border: 1,
    paddingRight: 8,
    fontStyle: 'normal',
  },
  originNo: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
    fontStyle: 'normal',
  },
  fileNumber: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
    fontStyle: 'normal',
  },
  voucherNo: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
    fontStyle: 'normal',
  },
  beneficiaries: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    border: 1,
    paddingLeft: 8,
    fontStyle: 'normal',
  },
  amount: {
    width: '25%',
    textAlign: 'right',
    bordertColor: tableBorderColor,
    border: 1,
    paddingRight: 8,
    fontStyle: 'normal',
  },
  date: {
    width: '25%',
    textAlign: 'left',
    bordertColor: tableBorderColor,
    paddingLeft: 8,
    border: 1,
    fontStyle: 'normal',
  },
});

function PDFPaymentVouchersReport({ title, content, isVisible, onClose, bigForm }) {
  let paymentVoucherReport = '';
  let voucherType = '';
  let subtotal = 0.0;
  let grandtotal = 0.0;
  // console.log("content.PaymentVoucher ::: ", content.PaymentVoucher)
  if (content.PaymentVoucher != undefined) {
    //cur_cat = content.PaymentVoucher[0].category;
    voucherType = content.PaymentVoucher[0].voucherTypeId;

    let pvs = [];
    let index=0;

    let pv = {};
    pv.sNo = '';
    pv.originNo = content.PaymentVoucher[0].voucherTypeName;
    pv.fileNumber = '';
    pv.voucherNo = '';
    pv.beneficiaries = '';
    pv.voucherDate = '';
    pv.amount = subtotal;
    pv.voucherTypeId = voucherType;
    pv.voucherTypeName = '';
    pvs.push(pv);

    paymentVoucherReport = content.PaymentVoucher.map((token) => {
      if(voucherType != token.voucherTypeId){
        pv = {};
        pv.sNo = '';
        pv.originNo = '';
        pv.fileNumber = '';
        pv.voucherNo = '';
        pv.beneficiaries = '';
        pv.voucherDate = 'Sub Total:';
        pv.amount = subtotal;
        pv.voucherTypeId = voucherType;
        pv.voucherTypeName = '';
        subtotal = 0.0;
        voucherType = token.voucherTypeId
        pvs.push(pv);

        pv = {};
        pv.sNo = '';
        pv.originNo = token.voucherTypeName;
        pv.fileNumber = '';
        pv.voucherNo = '';
        pv.beneficiaries = '';
        pv.voucherDate = '';
        pv.amount = '';
        pv.voucherTypeId = voucherType;
        pv.voucherTypeName = '';
        pvs.push(pv);
      }
      pv = {};
      pv.sNo = ++index;
      pv.originNo = token.originNo;
      pv.fileNumber = token.fileNumber;
      pv.voucherNo = token.voucherNo;
      pv.beneficiaries = token.beneficiaries;
      pv.voucherDate = token.voucherDate;
      pv.amount = token.amount;
      pv.voucherTypeId = token.voucherTypeId;
      pv.voucherTypeName = token.voucherTypeName;
      subtotal = subtotal + parseFloat(token.amount);
      grandtotal = grandtotal + parseFloat(token.amount);
      pvs.push(pv);
    })
    pv = {};
    pv.sNo = '';
    pv.originNo = '';
    pv.fileNumber = '';
    pv.voucherNo = '';
    pv.beneficiaries = '';
    pv.voucherDate = 'Sub Total:';
    pv.amount = subtotal;
    pv.voucherTypeId = voucherType;
    pv.voucherTypeName = '';
    pvs.push(pv);

    pv = {};
    pv.sNo = '';
    pv.originNo = '';
    pv.fileNumber = '';
    pv.voucherNo = '';
    pv.beneficiaries = '';
    pv.voucherDate = 'Grand Total:';
    pv.amount = grandtotal;
    pv.voucherTypeId = voucherType;
    pv.voucherTypeName = '';
    pvs.push(pv);
console.log(JSON.stringify(pvs))

    voucherType = content.PaymentVoucher[0].voucherTypeId;
    paymentVoucherReport = pvs.map((token, index) => {
      index++;
      
      let break_flag = true;
      ((voucherType !== token.voucherTypeId) ? voucherType = token.voucherTypeId : break_flag = false);
      return (
        <View style={styleRows.row} key={index.toString()} wrap={false} break={break_flag} >
          <Text style={styleRows.sno}>{token.sNo}</Text>
          <Text style={styleRows.originNo}>{token.originNo}</Text>
          <Text style={styleRows.fileNumber}>{token.fileNumber}</Text>
          <Text style={styleRows.voucherNo}>{token.voucherNo}</Text>
          <Text style={styleRows.beneficiaries}>{token.beneficiaries}</Text>
          <Text style={styleRows.date}>{token.voucherDate.substring(0, 10)}</Text>
          <Text style={styleRows.amount}>{token.amount !== '' ? token.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : ''}</Text>
        </View>
      )
    })
    // console.log(JSON.stringify(paymentVoucherReport))

  }

  return (
    isVisible && (
      <Modal
        style={bigForm ? Constants.defaultBigModalStyle : Constants.defaultModalStyle}
        isOpen={isVisible}
        ariaHideApp={false}
        onRequestClose={onClose ? () => onClose() : null}
        shouldCloseOnOverlayClick={false}
      >
        <div className="modal-content" style={{ height: "600px", width: "900px" }}>
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            {onClose && (
              <a href="#" className="close" onClick={() => onClose()}>
                <em className="icon ni ni-cross" />
              </a>
            )}
          </div>
          {/* originNo, fileNumber, voucherNo, beneficiaries, amount, voucherDate */}

          <div className="modal-body">
            <PDFViewer style={styles.viewer}>
              <Document>
                <Page style={styles.page} size="A4" orientation="landscape">
                  <Svg viewBox="0 -20 300 40" fixed>
                    <Rect x="85" y="10" rx="0" ry="0" width="95" height="15" fill="white" stroke={borderColor} strokeWidth={1} />
                    <Text x="106" y="20" style={{ fontSize: "5px" }}>PAYMENT VOUCHERS</Text>
                  </Svg>
                  {/* originNo, fileNumber, voucherNo, beneficiaries, voucherDate, amount */}

                  <View style={styleHeader.container} fixed>
                    <Text style={styleHeader.sno}>S/No</Text>
                    <Text style={styleHeader.originNo}>Departmental No</Text>
                    <Text style={styleHeader.fileNumber}>File No</Text>
                    <Text style={styleHeader.voucherNo}>Voucher No</Text>
                    <Text style={styleHeader.beneficiaries}>Payee</Text>
                    <Text style={styleHeader.date}>Date</Text>
                    <Text style={styleHeader.amount}>Amount</Text>
                  </View>
                  {paymentVoucherReport}

                  <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                    `${pageNumber} / ${totalPages}`
                  )} fixed />
                </Page>
              </Document>
            </PDFViewer>
          </div>
          <div className="modal-footer theme-bg py-0" style={{ height: "4px" }}></div>
        </div>
      </Modal>
    )
  );
}
export default PDFPaymentVouchersReport;